import { useFormik } from 'formik';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';

export const useFormikMfaPassword = (makeRequest: any) => {
  const intl = useIntl();

  return useFormik({
    initialValues: {
      code: '',
      applicationDeviceId: '3cdd5096-89fe-4f8e-b1b5-748c5b357400', 
    },
    validationSchema: Yup.object().shape({
      code: Yup.string().required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
    }),
    onSubmit: (submitValues) => {
      makeRequest(submitValues);
    },
  });
};
